import React from 'react';
import Button from "components/button";
import {AddIcon} from "assets/icons";
import UseModal from "components/modal/useModal";
import UseContext from "hooks/useContext";

const AdminSubnav = ({className = ''}) => {
    const {rest} = UseContext()
    const {toggle} = UseModal()

    const handleAdd = (e) => {
        e.preventDefault()
        toggle('admin_c_add')
    }
    if (rest === 0) return null;
    return (
        <>
            <div className={`flex items-center gap-3 pb-3 ${className}`}>
                <Button size={'LGI'} color={'PRIMARYFIXE'} onClick={handleAdd}>
                        <AddIcon wh={14} color={'#ffffff'}/>
                        Inviter un membre
                    </Button>
            </div>
        </>
    );
};

export default AdminSubnav;